import React from "react";
import styles from "./landing.module.scss";
import POOLBANLOGO from "assets/poolban-white-logo.png";
export const BackgroundAnimation = () => {
  return (
    <div className={styles.background_animation_container}>
      <div className={styles.area}>
        <ul className={styles.circles}>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
          <li>
            <img src={POOLBANLOGO} alt="poolban" width={"100%"} />
          </li>
        </ul>
      </div>
    </div>
  );
};
